import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Typography, Button, Fab, CircularProgress, IconButton, ListItem, List, ListItemText, Paper } from "@material-ui/core";
import { createHistory, formatDate, hasPermission } from "../../../sc-utilities";
import { Redirect } from "react-router-dom";
import { isSuperUser } from '../../../sc-utilities';
import BillingAccountDelete from '../../../sc-billing/BillingAccount/BillingAccountDelete'
import { Add, MoreHoriz } from '@material-ui/icons';
import { CustomChip } from '../../../sc-components';
import ModalSuspend from './SuspendAndRecoverAccount'
import Popover from '@material-ui/core/Popover';
import { CancelToken } from 'axios';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        height: 350,
        width: 300,
        marginRight: '10px',
    },
    submit: {
        marginRight: '80px',
    },
    control: {
        padding: theme.spacing(2),
    },
    typography: {
        textAlign: 'left',
        display: 'list-item',
        marginLeft: '20px'
    },
    chipActive: {
        color: theme.palette.success.dark,
    },
    typography2: {
        fontSize: 12,
        color: theme.palette.buttonText.default
    },
    chipPrepared: {
        color: theme.palette.warning.dark,
    },
    chipInactive: {
        color: theme.palette.error.dark,
    },
    buttonStyleActive: {
        color: theme.palette.buttonText.default,
        backgroundColor: '#ff5722'
    },
    buttonStyleInActive: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark
    },
    buttonStyleDelete: {
        width: '99%',
        bottom: ' 45px'
    },
    buttonStyleDeleteAdmin: {
        width: '99%',
        marginTop: 15,
        marginBottom: 15
    },
    button: {
        marginTop: 5,
    },
    noAcc: {
        marginTop: '3rem',
        marginBottom: '3rem',
        textAlign: 'center'
    },
    container: {
        padding: '30px',
        margin: theme.spacing(1)
    }
}));

const AccountSection = props => {
    const { accounts, onListCustomers, currentUserID, onListUsers, onDeleteBillingAccount, sendMessage, onCleanState, customerID, onLoadCustomer, onSuspend, onRecover, activeCustomer, translations, permissions } = props;

    const [accountModalState, setAccountModalState] = useState({ AccountID: null, open: false, recover: false })
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const cancelToken = CancelToken.source();
    const cancelTokenUsers = CancelToken.source();
    const cancelTokenCustomers = CancelToken.source();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        onLoadCustomer({ CustomerID: customerID, ActiveCustomerID: activeCustomer }, { cancelToken: cancelToken });

        return () => {
            onCleanState()
            cancelToken.cancel('Operation canceled by the user.');
            cancelTokenUsers.cancel('Operation canceled by the user.');
            cancelTokenCustomers.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerID, activeCustomer, onLoadCustomer]);


    const [deleteModalState, setDeleteModalState] = useState({
        open: false,
        billingAccountID: null,
        billingAccountIDs: [],
        forBulk: false
    });

    const [redirectOptions, setRedirectOptions] = useState({ path: null, data: null, formLoading: false });

    const handleSuspend = billingAccountID => {
        setAccountModalState({ ...accountModalState, AccountID: billingAccountID, open: true })
    };

    const handleRecover = billingAccountID => {
        setAccountModalState({ AccountID: billingAccountID, open: true, recover: true })
    };

    const goToAccountOverview = billingAccountID => {
        createHistory();
        setRedirectOptions({
            ...redirectOptions,
            redirect: true,
            data: billingAccountID,
            path: `/billing/accounts-overview?billingAccountID=${billingAccountID}`
        });
    };

    const handleDelete = async ID => {
        if (!ID) {
            setDeleteModalState({ open: false, billingAccountID: null, billingAccountIDs: [], forBulk: false });
            return;
        }
        const billingAccountID = ID;
        setDeleteModalState({ ...deleteModalState, open: true, billingAccountID: billingAccountID });
    };

    const handleOpen = async () => {
        setRedirectOptions({ ...redirectOptions, formLoading: true });
        let data = await onListCustomers({ ActiveCustomerID: activeCustomer }, { cancelToken: cancelTokenCustomers });
        let userData = await onListUsers({ ActiveCustomerID: activeCustomer }, { cancelToken: cancelTokenUsers });
        if (data.length === 0) {
            sendMessage(
                `${translations['need_at_least'] || 'You need at least one Customer'}. ${translations['please_create'] || 'Please create it'}.`,
                'warning'
            );
            return;
        }
        const redirectData = {
            customers: data,
            users: userData,
            currentUserID: currentUserID
        };
        createHistory();
        setRedirectOptions({ path: `/billing/create?customerID=${customerID}`, data: redirectData, formLoading: false });
    };

    const handleCloseDanger = async () => {
        await onDeleteBillingAccount({ ActiveCustomerID: activeCustomer, AccountID: deleteModalState.billingAccountID })
        setDeleteModalState({ open: false, billingAccountID: null, billingAccountIDs: [], forBulk: false });

    }

    const handleOpenRecover = () => {
        setAccountModalState({ AccountID: null, open: false, recover: false })
    };

    if (redirectOptions.path && redirectOptions.data) {
        return (
            <Redirect
                to={redirectOptions.path}
            />
        );
    }
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const getFormattedStatus = (id, status) => {
        switch (status) {
            case 'active':
                return <CustomChip key={`${id}`} className={classes['chipActive']} value={translations['active'] || 'Active'} />;
            case 'inactive':
                return <CustomChip key={`${id}`} className={classes['chipInactive']} value={translations['inactive'] || 'Inactive'} />;
            case 'prepared':
                return <CustomChip key={`${id}`} className={classes['chipPrepared']} value={translations['prepared'] || 'Prepared'} />;
            default:
                return '';
        }
    };

    return <div className={classes.container}>
        {hasPermission(permissions, 'billing_account_create') ? <Fab
            variant="extended"
            size="small"
            style={{ borderRadius: '1px', marginBottom: '10px' }}
            color={'primary'}
            aria-label="Add"
            disabled={redirectOptions.formLoading}
            onClick={() => handleOpen()}
        >
            <Add />
            {redirectOptions.formLoading ? <CircularProgress size={24} /> : <Typography className={classes.typography2} >
                {translations['create_new'] || 'Create new'}
            </Typography>}
        </Fab> : null}

        <Grid container className={classes.root} spacing={10}>
            {accounts && accounts.length < 1 ?
                <Typography variant='subtitle1' className={classes.noAcc}> {translations['sorry_no_accounts'] || 'Sorry, no accounts available'} </Typography> : null}
            {accounts && accounts.map(account => (!account.Deleted ?
                <Grid className={classes.submit} container key={account.AccountID} item
                    lg={3}
                    sm={6}
                    xl={3}
                    xs={12} direction={'column'}>
                    <Paper className={classes.paper}>
                        <div className={classes.customDiv}
                            style={{
                                width: '100%',
                                height: hasPermission(permissions, 'billing_account_delete') || hasPermission(permissions, 'billing_account_suspend_or_recover') ? '85%' : '100%'
                            }}>
                            <div style={{ textAlign: "right" }}>
                                {hasPermission(permissions, 'billing_account_delete') && (hasPermission(permissions, 'billing_account_suspend_or_recover')) ?
                                    <div>
                                        <IconButton onClick={handleClick}>
                                            <MoreHoriz  ></MoreHoriz>
                                        </IconButton>
                                        <Popover
                                            id={id}
                                            open={open}
                                            anchorEl={anchorEl}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                        >
                                            <Paper>
                                                <List component="nav" aria-label="secondary mailbox folders">
                                                    {hasPermission(permissions, 'billing_account_suspend_or_recover') ?
                                                        <ListItem onClick={account.Status === 'inactive' ? () => handleRecover(account.AccountID) : () => handleSuspend(account.AccountID)} button href="#simple-list">
                                                            <ListItemText primary={account.Status === 'inactive' ? translations['recover'] || "Recover" : translations['suspend'] || "Suspend"} />
                                                        </ListItem>
                                                        : null}
                                                    {hasPermission(permissions, 'billing_account_delete') ?
                                                        <ListItem onClick={() => handleDelete(account.AccountID)} button>
                                                            <ListItemText primary="Delete" />
                                                        </ListItem>
                                                        : null}
                                                </List>
                                            </Paper>
                                        </Popover>
                                    </div> : null}
                            </div>
                            <Typography className={classes.typography}
                                variant={"caption"}>{account.BillingMode === 'prepaid' ? translations['prepaid'] || 'Prepaid' : translations['postpaid'] || 'Postpaid'}
                            </Typography><br />
                            <Typography className={classes.typography} variant={"caption"}> {translations['created_at'] || 'Created at'}{' '}
                                - {formatDate(account.CreatedAt)} </Typography> <br></br>
                            <Typography className={classes.typography} variant={"caption"}>{translations['activation'] || 'Activation'}{' '}
                                {translations['date'] || 'date '} - {formatDate(account.ActivationDate)} </Typography> <br></br>
                            <Typography className={classes.typography} variant={"caption"}>{translations['billing'] || 'Billing'}{' '}
                                {translations['day_every'] || 'day - Every'}      {account.BillingDay}.{translations['in_month'] || 'in month'}  </Typography> <br></br>
                            <Typography className={classes.typography} variant={"caption"}>{translations['expires_at'] || 'Expires at'}{' '}
                                - {formatDate(account.ExpiresAt)} </Typography> <br></br>
                            <Typography className={classes.typography}
                                variant={"caption"}> {getFormattedStatus(account.AccountID, account.Status)}</Typography><br></br>
                        </div>
                        <div style={{ width: '100%' }}>
                            {hasPermission(permissions, 'billing_account_load') ?
                                <Button className={isSuperUser() ? classes.buttonStyleDeleteAdmin : classes.buttonStyleDelete} variant="outlined" color={'primary'}
                                    onClick={() => goToAccountOverview(account.AccountID)}
                                >
                                    {translations['view_complete_profile'] || "VIEW COMPLETE PROFILE"}
                                </Button> : <></>}
                        </div>
                    </Paper>
                </Grid>
                : null))}
            <BillingAccountDelete translations={translations} activeCustomer={activeCustomer}
                entityName={translations['billing_account'] || 'Billing Account'} handleDelete={handleDelete}
                deleteModalState={deleteModalState}
                handleCloseSafe={() => handleDelete(null)}
                handleCloseDanger={handleCloseDanger} />
            <ModalSuspend translations={translations} activeCustomer={activeCustomer} handleOpen={handleOpenRecover} accountModalState={accountModalState} onRecover={onRecover}
                onSuspend={onSuspend} />
        </Grid>
    </div >
};

export default AccountSection;